import { getReqAuth } from '../../api';
import axios from 'axios';
import config from '../../../util/config';

export const getInstitutionConfig = (cb) => {
  getReqAuth('/webapi/institute/institutionConfig', {}, '', cb);
};

export const updateInstitutionConfig = (data, cb) => {
  const token = localStorage.getItem('jwtToken');

  if (token) {
    axios.defaults.headers.common.Authorization = token;
    axios
      .put(config.BASE_API_URL + '/webapi/institute/institutionConfig', data)
      .then((res) => {
        cb(null, res.data);
      })
      .catch((err) => {
        cb(err, null);
      });
  } else {
    cb('Not authenticated', null);
  }
};

export const clearRedisCache = (cb) => {
  const token = localStorage.getItem('jwtToken');

  if (token) {
    axios.defaults.headers.common.Authorization = token;
    axios
      .post(config.BASE_API_URL + '/webapi/institute/institutionConfig/clearCache')
      .then((res) => {
        cb(null, res.data);
      })
      .catch((err) => {
        cb(err, null);
      });
  } else {
    cb('Not authenticated', null);
  }
};
